import { IYxInputPropTypes } from "./basePropType";
import PropType from "prop-types";

export const IRadioPropTypes = {
  ...IYxInputPropTypes,
  //控件类型group-分组,""-单个
  type: PropType.oneOf(["", "group"]),

  //分组数据
  data: PropType.array,

  //按钮风格样式，outline/solid/icon/img，当type='group'时生效
  buttonStyle: PropType.oneOf(["outline", "solid", "icon", "img"]),
};

export const radioDefaultProps =()=> ( {
  inputParam: {},
  children: "", //子节点,子节点暂时只支持antd的Checkbox
  type: "group", //类型，分组模式
  data: [], //分组的数据
  rules: {
    max: "",
  },
  styleParam: {
    size: "default", //大小
    type: "default", //类型
  },
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/radioPropType.js